/* eslint-disable max-len */
import React from 'react';
import { HighContrastSelector, memoizeFunction, mergeStyles } from '@fluentui/react';
import { IAppTheme } from 'common/theme';

export const getIconFill = memoizeFunction((theme: IAppTheme) =>
  mergeStyles({
    color: theme.appColors?.lightHeadlineText,
    [HighContrastSelector]: {
      color: 'ButtonText',
    },
  })
);

const PlatformAndroid = (props: { key: string; theme: IAppTheme }) => {
  const { theme } = props;
  const iconClassName = getIconFill(theme);
  return (
    <svg
      width="23"
      height="14"
      viewBox="0 0 23 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClassName}
      aria-hidden="true"
    >
      <g clipPath="url(#clip0_1184_8777)">
        <path
          d="M16.6102 10.4595C16.0874 10.4595 15.6626 9.99546 15.6626 9.42444C15.6626 8.85341 16.0874 8.3894 16.6102 8.3894C17.1329 8.3894 17.5578 8.85341 17.5578 9.42444C17.5578 9.99546 17.1329 10.4595 16.6102 10.4595ZM6.13984 10.4595C5.61706 10.4595 5.19225 9.99546 5.19225 9.42444C5.19225 8.85341 5.61706 8.3894 6.13984 8.3894C6.66262 8.3894 7.08743 8.85341 7.08743 9.42444C7.08743 9.99546 6.66262 10.4595 6.13984 10.4595ZM16.95 4.22652L18.8435 0.644131C18.9518 0.438639 18.8877 0.175381 18.6995 0.056063C18.5114 -0.0623082 18.2704 0.00776756 18.1612 0.21326L16.2443 3.84015C14.7783 3.10909 13.1319 2.7019 11.3754 2.7019C9.61896 2.7019 7.9726 3.10909 6.50656 3.84015L4.58884 0.214207C4.4796 0.00871453 4.23859 -0.0623082 4.05046 0.05701C3.86232 0.176328 3.7973 0.438639 3.90654 0.645078L5.79999 4.22652C2.54887 6.15739 0.325111 9.75209 0 13.9992H22.75C22.424 9.75209 20.2011 6.15739 16.95 4.22557"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1184_8777">
          <rect width="22.75" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const PlatformApple = (props: { key: string; theme: IAppTheme }) => {
  const { theme } = props;
  const iconClassName = getIconFill(theme);
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClassName}
      aria-hidden="true"
    >
      <g clipPath="url(#clip0_1184_8779)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.86627 1.39228C7.86935 0.00683396 9.26363 0 9.26363 0C9.26363 0 9.47102 1.30265 8.47471 2.55772C7.41069 3.89769 6.20148 3.67848 6.20148 3.67848C6.20148 3.67848 5.97453 2.62474 6.86627 1.39254V1.39228Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.32893 4.59079C6.84501 4.59079 7.80245 3.84747 9.04902 3.84747C11.1946 3.84747 12.0387 5.44766 12.0387 5.44766C12.0387 5.44766 10.3879 6.33238 10.3879 8.47902C10.3879 10.9006 12.4444 11.7351 12.4444 11.7351C12.4444 11.7351 11.0068 15.9763 9.06507 15.9763C8.17309 15.9763 7.47996 15.3463 6.54007 15.3463C5.60019 15.3463 4.63222 15.9997 4.01332 15.9997C2.24013 16 0 11.9769 0 8.74291C0 5.5089 1.89607 3.89189 3.67453 3.89189C4.83058 3.89189 5.72783 4.59079 6.32893 4.59079Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1184_8779">
          <rect width="12.4444" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const PlatformWindows = (props: { key: string; theme: IAppTheme }) => {
  const { theme } = props;
  const iconClassName = getIconFill(theme);
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClassName}
      aria-hidden="true"
    >
      <rect x="1.33337" y="1.33331" width="6.33333" height="6.33333" fill="currentColor" />
      <rect x="8.33337" y="1.33331" width="6.33333" height="6.33333" fill="currentColor" />
      <rect x="8.33337" y="8.33331" width="6.33333" height="6.33333" fill="currentColor" />
      <rect x="1.33337" y="8.33331" width="6.33333" height="6.33333" fill="currentColor" />
    </svg>
  );
};

export { PlatformAndroid, PlatformApple, PlatformWindows };
